import { Registration } from '~/apis/ssf';

export function formatPoints(points: number) {
  return points.toFixed(2);
}

// Sum of individual scores for a team, excluding withdrawn and reserve lifters.
export function teamScoreTotal(registrations: Registration[]) {
  return registrations
    .filter(r => r.state !== 'WITHDRAWN' && !r.is_reserve)
    .reduce((sum, r) => sum + (r.nomination_result ?? 0), 0);
}

// Orders two groups of team-competition registrations so groups of the same division stay
// adjacent (divisions ordered alphabetically, Swedish collation), and within a division the
// highest-scoring teams sort first. Teamless groups sort last.
export function compareTeamGroups(a: Registration[], b: Registration[]) {
  const divA = a[0]?.team?.division?.name;
  const divB = b[0]?.team?.division?.name;

  if (divA !== divB) {
    if (!divA) return 1;
    if (!divB) return -1;
    return divA.localeCompare(divB, 'sv');
  }

  return teamScoreTotal(b) - teamScoreTotal(a);
}
